import React from "react";

export const processGatewayCode = (arr, key) => {
    return arr.map((item) => {
        console.log('response',item,item.response[key]);
        
      switch (item.response[key]) {
        case 'ABORTED':
          return 'Transaction aborted by payer';
        
        case 'ACQUIRER_SYSTEM_ERROR':
          return 'Acquirer system error occurred processing the transaction';

        case 'ABORTED':
          return 'Transaction aborted by payer';

        case 'APPROVED':
          return 'Transaction Approved';
        
        case 'APPROVED_AUTO':
          return 'The transaction was automatically approved by the gateway. it was not submitted to the acquirer.';
        
        case 'APPROVED_PENDING_SETTLEMENT':
          return 'Transaction Approved - pending batch settlement';
        
        case 'AUTHENTICATION_FAILED':
          return 'Payer authentication failed';

        case 'AUTHENTICATION_IN_PROGRESS':
          return 'The operation determined that payer authentication is possible for the given card, but this has not been completed, and requires further action by the merchant to proceed.';
        
        case 'BALANCE_AVAILABLE':
          return 'A balance amount is available for the card, and the payer can redeem points.';

        case 'BALANCE_UNKNOWN':
          return 'A balance amount might be available for the card. Points redemption should be offered to the payer.';
        
        case 'BLOCKED':
          return 'Transaction blocked due to Risk or 3D Secure blocking rules';

        case 'CANCELLED':
        return 'Transaction cancelled by payer';

        case 'DECLINED':
          return 'The requested operation was not successful. For example, a payment was declined by issuer or payer authentication was not able to be successfully completed.';
        
        case 'DECLINED_AVS':
          return 'Transaction declined due to address verification';

        case 'DECLINED_AVS_CSC':
          return 'Transaction declined due to address verification and card security code';

        case 'DECLINED_CSC':
          return 'Transaction declined due to card security code';

        case 'DECLINED_CSC':
          return 'Transaction declined due to card security code';

        case 'DECLINED_DO_NOT_CONTACT':
          return 'Transaction declined - do not contact issuer';

        case 'DECLINED_INVALID_PIN':
          return 'Transaction declined due to invalid PIN';

        case 'DECLINED_PAYMENT_PLAN':
          return 'Transaction declined due to payment plan';

        case 'DECLINED_PIN_REQUIRED':
          return 'Transaction declined due to PIN required';

        case 'DEFERRED_TRANSACTION_RECEIVED':
          return 'Deferred transaction received and awaiting processing';

        case 'DUPLICATE_BATCH':
          return 'Transaction declined due to duplicate batch';

        case 'EXCEEDED_RETRY_LIMIT':
          return 'Transaction retry limit exceeded';

        case 'EXPIRED_CARD':
          return 'Transaction declined due to expired card';

        case 'INSUFFICIENT_FUNDS':
          return 'Transaction declined due to insufficient funds';
      
        case 'INVALID_CSC':
          return 'Invalid card security code';

        case 'LOCK_FAILURE':
          return 'Order locked - another transaction is in progress for this order';

        case 'NOT_ENROLLED_3D_SECURE':
          return 'Card holder is not enrolled in 3D Secure';

        case 'NOT_SUPPORTED':
          return 'Transaction type not supported';

        case 'NO_BALANCE':
          return 'A balance amount is not available for the card. The payer cannot redeem points.';

        case 'PARTIALLY_APPROVED':
          return 'The transaction was approved for a lesser amount than requested.';

        case 'PENDING':
          return 'Transaction is pending';

        case 'SUBMITTED':
          return 'The transaction has successfully been created in the gateway. It is either awaiting submission to the acquirer or has been submitted to the acquirer but the gateway has not yet received a response about the success or otherwise of the payment.';

        case 'SYSTEM_ERROR':
          return 'Internal system error occurred processing the transaction';

        case 'TIMED_OUT':
          return 'The gateway has timed out the request to the acquirer because it did not receive a response. Points redemption should not be offered to the payer.r';

        case 'UNKNOWN':
          return 'The transaction has been submitted to the acquirer but the gateway was not able to find out about the success or otherwise of the payment. If the gateway subsequently finds out about the success of the payment it will update the response code.';

        case 'UNSPECIFIED_FAILURE':
          return 'Transaction could not be processed';

        default:
          return '-';
      }
    });
  };